import RouterModule from './modules' // 引入业务逻辑模块

export default [
  // 默认页
  {
    path: '/',
    redirect: '/home',
  },
  // 404
  {
    path: '*',
    name: '404',
    component: resolve => require(['@/components/404'], resolve),
    meta: {
      title: '404',
    }
  },
  {
    path: '/home',
    name: 'home',
    component: resolve => require(['@/views/home'], resolve),
    meta: {
      title: '票务预约',
    },
  },
  {
    path: '/ticket',
    name: 'ticket',
    redirect: '/ticket/person',
    component: resolve => require(['@/views/ticket'], resolve),
    meta: {
      title: '票务预约',
    },
    children: [
      ...RouterModule,
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/common.js